import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/m4YZZdBywTX6pbKNJuyFtG/Imagen.Hero.webp';
const PRODUCT_NAME = 'El Fin de las Rabietas';
const PRICE = '$6.39';
const cities = ['Houston, TX', 'Miami, FL', 'Los Angeles, CA', 'San Antonio, TX', 'Chicago, IL', 'Dallas, TX', 'Phoenix, AZ', 'New York, NY', 'Orlando, FL', 'Denver, CO', 'Atlanta, GA', 'San Diego, CA'];
const names = ['María', 'Ana', 'Sofía', 'Laura', 'Camila', 'Valentina', 'Isabella', 'Gabriela', 'Daniela', 'Lucía', 'Carmen', 'Rosa', 'Patricia', 'Elena', 'Andrea'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 2;
}
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [minutes, setMinutes] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  // Only show on mobile
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile, {
      passive: true
    });
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  useEffect(() => {
    if (!isMobile) return;
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    let loopInterval: ReturnType<typeof setInterval>;
    const showNotification = () => {
      setName(getRandomItem(names));
      setCity(getRandomItem(cities));
      setMinutes(getRandomMinutes());
      setVisible(true);
      hideTimeout = setTimeout(() => setVisible(false), 3000);
    };
    // First notification after 12 seconds
    showTimeout = setTimeout(showNotification, 12000);
    // Loop: 3s visible + 5s hidden = 8s cycle
    loopInterval = setInterval(() => {
      showNotification();
    }, 8000);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
      clearInterval(loopInterval);
    };
  }, [isMobile]);
  if (!isMobile) return null;
  return <AnimatePresence data-id="element-2">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0,
      scale: 0.95
    }} animate={{
      y: 0,
      opacity: 1,
      scale: 1
    }} exit={{
      y: 20,
      opacity: 0,
      scale: 0.97
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 28,
      mass: 0.8
    }} className="fixed bottom-6 left-3 right-3 z-50 md:hidden" data-id="element-3">
          <div className="mx-auto max-w-sm rounded-2xl px-3.5 py-3 flex items-center gap-3 border border-white/20" style={{
        background: 'rgba(255, 255, 255, 0.92)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06)'
      }} data-id="element-4">
            {/* Product image */}
            <img src={PRODUCT_IMAGE} alt={PRODUCT_NAME} className="w-11 h-11 rounded-xl object-cover shrink-0" loading="lazy" data-id="element-5" />

            {/* Text content */}
            <div className="flex-1 min-w-0" data-id="element-6">
              <p className="text-[13px] leading-[1.35] text-gray-900" style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif'
          }} data-id="element-7">
                <strong data-id="element-8">{name}</strong> de {city} compró{' '}
                <strong data-id="element-9">{PRODUCT_NAME}</strong> por{' '}
                <strong className="text-green-600" data-id="element-10">{PRICE}</strong>
              </p>
              <p className="text-[11px] text-gray-400 mt-0.5" style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif'
          }} data-id="element-11">
                hace {minutes} min
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}